<template>
  <div class="listBox">
    <el-select
      v-model="villageName"
      placeholder="请选择"
      class="selectBox"
      @change="selectVideo"
    >
      <el-option
        v-for="item in options"
        :key="item.villageName"
        :label="item.villageName"
        :value="item.villageName"
      >
      </el-option>
    </el-select>
    <div class="listvideo">
      <div
        v-for="(item, index) in videoList"
        :key="index"
        @click="videoPlay(item.indexCode)"
      >
        <img src="@/assets/images/videoBtn.png" class="videobg"/>
        <p class="titleP">{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "slidervideo",
  data() {
    return {
      options: [],
      videoList: [],
      indexCode: "",
      keywords: {},
      url: "",
      villageName:'',
      playList:''
    };
  },
  mounted() {
    this.getVillageList();
    this.getKeywords();
  },
  methods: {
    // 获取乡镇列表
    getVillageList() {
      var resData = plOtherDataInterface.getVillageList();
      this.options = resData;
      this.villageName = resData[0].villageName;
      this.getListTree();
    },
    // 获取视频列表
    getListTree() {
      this.playList='';
      var resData = plOtherDataInterface.getVideoListTree(this.villageName);
      let arr=[];
      resData.forEach((item,index) => {
        arr.push(item.indexCode)
        this.playList=arr.join(",")
      });
      this.videoList = resData;
       console.log(this.playList)
    },
    // 选择框选中函数
    selectVideo(e) {
      console.log(e)
      this.villageName = e;
      this.getListTree();
    },
    // 获取播放关键字
    getKeywords() {
      this.keywords = plOtherDataInterface.getVideoKeywords();
    },
    // 播放按钮
    videoPlay(videoId) {
      var SvrIp = this.keywords.artemisIp;
      var SvrPort = this.keywords.artemisPort;
      var appkey = this.keywords.appKey;
      var appSecret = this.keywords.appSecret;
      var time = this.keywords.time;
      var timeSecret = this.keywords.timeSecret;
      var schema = this.keywords.schema;
      var httpsflag = 1;
      if (schema == "http") {
        httpsflag = 0;
      }
      var n = Number(time);
      if (!isNaN(n)) {
        if (time.length == 14 || n > 19700101000000) {
          this.url =
            "hikvideoclient://ReqType:PlayReal" +
            ";" +
            "VersionTag:artemis" +
            ";" +
            "SvrIp:" +
            SvrIp +
            ";" +
            "SvrPort:" +
            SvrPort +
            ";" +
            "Appkey:" +
            appkey +
            ";" +
            "AppSecret:" +
            appSecret +
            ";" +
            "time:" +
            time +
            ";" +
            "timesecret:" +
            timeSecret +
            ";" +
            "httpsflag:" +
            httpsflag +
            ";" +
            "CamList:"+this.playList+";";
        } else {
          alert("播放时间有误.");
        }
      } else {
        alert("播放时间有误.");
      }
      this.openUriWithInputTimeoutHack(
        this.url,
        () => {
          this.open();
          console.log("检测到，未安装客户端");
        },
        () => {
          // 浏览器弹窗提示
          window.location.href = this.url;
          console.log("检测到：已安装了客户端");
        }
      );
    },
    // 下载弹框
    open() {
      this.$confirm("未找到播放器客户端, 是否安装?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.location.href =
            "https://218.95.150.214:9999/artemis/portal/downloadCenter/downloadFile?fileId=589&dId=34";
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消播放",
          });
        });
    },

    openUriWithInputTimeoutHack(uri, failCb, successCb) {
      let target = document.createElement("input");
      target.style.width = "0";
      target.style.height = "0";
      target.style.position = "fixed";
      target.style.top = "0";
      target.style.left = "0";
      document.body.appendChild(target);

      target.focus();
      var handler = this._registerEvent(target, "blur", onBlur);
      console.log("focus");
      function onBlur() {
        console.log("blur");
        successCb && successCb();
        handler.remove();
        clearTimeout(timeout);
        document.body.removeChild(target);
      }

      window.location.href = uri;

      var timeout = setTimeout(function () {
        console.log("setTimeout");
        failCb && failCb();
        handler.remove();
        document.body.removeChild(target);
      }, 1000);
    },

    _registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb);
        return {
          remove: function () {
            target.removeEventListener(eventType, cb);
          },
        };
      } else {
        target.attachEvent(eventType, cb);
        return {
          remove: function () {
            target.detachEvent(eventType, cb);
          },
        };
      }
    },
  },
};
</script>

<style scoped>
.listBox {
  margin-top: 10px;
  border-top: 1px solid rgb(125, 243, 164);
  overflow: auto;
  padding: 20px 10px;
  height: 580px;
}
.selectBox {
  margin-bottom: 20px;
}
.listvideo {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
   justify-content: flex-start;
}
.listvideo div{
  width: 33.333%;
}

.titleP {
  height: 25px;
  width: 300px;
  font-size: 18px;
  text-align: center;
  color: #00ffce;
  margin-top: 14px;
  margin-bottom: 23px;
}
.footerBox {
  width: 100%;
  position: absolute;
  bottom: 30px;
  margin: auto;
}
.paginationBox {
  width: 40%;
  margin: auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.paginationBox span {
  width: 50px;
  height: 32px;
  font-size: 18px;
  font-family: AdobeHeitiStd-Regular;
  text-align: center;
  color: #ffffff;
  line-height: 32px;
  letter-spacing: 2px;
}
.pagination {
  width: 80px;
  height: 32px;
  display: inline-block;
  background: rgba(0, 255, 255, 0.15);
  font-size: 20px;
  font-family: AdobeHeitiStd-Regular;
  text-align: center;
  color: #1de9b6;
  line-height: 32px;
  letter-spacing: 2px;
}

::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */

.videobg{
    width: 300px;
    height: 210px; 
}
.selectBox >>> .el-input--suffix .el-input__inner {
    background-color: rgba(138, 206, 254, 0.3);
    color: #ffffff;
}

/* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: #909499 !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/rightAside/detail_video/surveillanceList.vue